import { useMemo } from 'react'

import { ContentModuleType } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

export const useEventModuleAvailability = () => {
  const { data: network } = useNetwork()
  const { availableSpaces } = useMemo(() => {
    return {
      availableSpaces: network?.contentModules
        ?.filter(module => module.contentModuleType === ContentModuleType.event)
        ?.flatMap(module => module.authMemberProps?.availableSpaces),
    }
  }, [network])
  const isEventModuleEnabledOnNetwork =
    !!network?.usages?.usages?.eventContentModuleAccess

  return {
    isEventModuleEnabledOnNetwork,
    availableSpaces,
  }
}
